import classNames from 'classnames';
import './MainFixedWidthBox.css';

type Props = React.ComponentProps<'div'> & {};

export const MainFixedWidthBox = ({ className, ...props }: Props) => {
  return <div className={classNames('help-fixedwith-box', className)} {...props} />;
};
